import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=c2ff28ea&scoped=true&"
import script from "./SimpleButton.vue?vue&type=script&lang=js&"
export * from "./SimpleButton.vue?vue&type=script&lang=js&"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&id=c2ff28ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ff28ea",
  null
  
)

export default component.exports